import React, { useState, useEffect } from "react";
import { Box, Grid, TextField, Typography, Button, CircularProgress, Paper, Chip, Alert } from "@mui/material";
import { Save, MessageCircle, ExternalLink } from "lucide-react";
import { useTranslation } from "react-i18next";
const PLACEHOLDERS = [{
  key: "{items}",
  desc: "Cart items list"
}, {
  key: "{total}",
  desc: "Order total"
}, {
  key: "{currency}",
  desc: "Currency symbol"
}, {
  key: "{payment_method}",
  desc: "Selected payment method"
}, {
  key: "{customer_name}",
  desc: "Customer name"
}, {
  key: "{customer_phone}",
  desc: "Customer phone"
}, {
  key: "{site_name}",
  desc: "Your site name"
}];
const CartWhatsAppTab = ({
  settings,
  save,
  saving
}) => {
  const {
    t
  } = useTranslation("website");
  const [form, setForm] = useState({});
  useEffect(() => {
    if (settings) setForm({
      whatsappNumber: settings.whatsappNumber || "",
      whatsappMessageTemplate: settings.whatsappMessageTemplate || "مرحباً، أود تقديم طلب\n\n*الطلب:*\n{items}\n\n*المجموع:* {total} {currency}\n*طريقة الدفع:* {payment_method}\n*الاسم:* {customer_name}\n*الهاتف:* {customer_phone}"
    });
  }, [settings]);
  const set = (key, val) => setForm(f => ({
    ...f,
    [key]: val
  }));
  const insertPlaceholder = key => set("whatsappMessageTemplate", (form.whatsappMessageTemplate || "") + key);
  const previewMessage = (form.whatsappMessageTemplate || "").replace("{items}", "- Apple Juice × 2 = 10 SAR\n- Orange Juice × 1 = 5 SAR").replace("{total}", "15").replace("{currency}", form.currencySymbol || "SAR").replace("{payment_method}", "Cash on Delivery").replace("{customer_name}", "Ahmed Mohammed").replace("{customer_phone}", "0512345678").replace("{site_name}", settings?.siteName || "My Store");
  const testLink = form.whatsappNumber ? `https://wa.me/${form.whatsappNumber.replace(/\D/g, "")}?text=${encodeURIComponent(previewMessage)}` : null;
  return <Box>
      <Alert severity="info" sx={{
      mb: 3
    }}>{t("When a customer submits an order, a pre-filled WhatsApp message will open with all order details. The cart is stored in the visitor's browser — no backend order is created unless you add it later.")}


      </Alert>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField label={t("WhatsApp Business Number")} value={form.whatsappNumber || ""} onChange={e => set("whatsappNumber", e.target.value)} fullWidth placeholder="966512345678" helperText={t("International format without + (e.g. 966512345678)")} />
          
        </Grid>

        <Grid item xs={12}>
          <Typography variant="subtitle2" gutterBottom>{t("Message Template")}</Typography>
          <Typography variant="caption" color="text.secondary" display="block" sx={{
          mb: 1
        }}>{t("Click a placeholder to insert it at the end of the template.")}

          </Typography>
          <Box sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 0.75,
          mb: 1.5
        }}>
            {PLACEHOLDERS.map(p => <Chip key={p.key} label={p.key} size="small" variant="outlined" clickable onClick={() => insertPlaceholder(p.key)} title={p.desc} />)}
          </Box>
          <TextField value={form.whatsappMessageTemplate || ""} onChange={e => set("whatsappMessageTemplate", e.target.value)} fullWidth multiline rows={7} inputProps={{
          style: {
            fontFamily: "monospace",
            fontSize: 13
          }
        }} />
          
        </Grid>

        {/* Preview */}
        <Grid item xs={12}>
          <Typography variant="subtitle2" gutterBottom>{t("Message Preview")}</Typography>
          <Paper variant="outlined" sx={{
          p: 2,
          bgcolor: "#e8f5e9",
          borderRadius: 2
        }}>
            <Box sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mb: 1
          }}>
              <MessageCircle size={16} color="#25D366" />
              <Typography variant="caption" color="text.secondary">{t("WhatsApp preview")}</Typography>
            </Box>
            <Typography variant="body2" sx={{
            whiteSpace: "pre-wrap",
            fontFamily: "monospace",
            fontSize: 13
          }}>
              {previewMessage}
            </Typography>
          </Paper>
          {testLink && <Button size="small" variant="outlined" href={testLink} target="_blank" startIcon={<ExternalLink size={14} />} sx={{
          mt: 1
        }}>{t("Test on WhatsApp")}


          </Button>}
        </Grid>

        <Grid item xs={12}>
          <Button variant="contained" onClick={() => save(form)} disabled={saving} startIcon={saving ? <CircularProgress size={16} /> : <Save size={16} />}>{t("Save WhatsApp Settings")}


          </Button>
        </Grid>
      </Grid>
    </Box>;
};
export default CartWhatsAppTab;
